import { FormControl } from '@angular/forms';
import { Polygon } from 'geojson';

import { ProjectColors } from '@connect-services/client/components/color-dropdown/color-dropdown.component';
import { Project } from '@connect-services/client/sdk/api';
import { ProjectCreationEditionForm } from '@connect-services/client/services/project/shaping/shaping-project.service';
import { ValidatorsService } from '@connect-services/client/services/validators.service';
import { FormService } from '@shared/client/services/form.service';

export type ProjectDefaultData = {
    bbox: Polygon | null;
    color?: ProjectColors;
    name?: string;
    projection?: Project.ProjectionEnum;
};
export abstract class ShapingProjectState {
    protected defaultData?: ProjectDefaultData;

    public abstract form: ProjectCreationEditionForm;
    public abstract title: string;

    protected initForm(): void {
        this.form = new ProjectCreationEditionForm({
            bbox: new FormControl<Polygon | null>(this.getDefaultData()?.bbox ?? null),
            color: new FormControl(this.getDefaultData()?.color ?? ProjectColors.AZURE, {
                nonNullable: true,
            }),
            name: new FormControl<string>(this.getDefaultData()?.name ?? '', {
                nonNullable: true,
                validators: [
                    ...ValidatorsService.stringValidationForm({
                        maxLength: FormService.VARCHAR_MEDIUM_LENGTH,
                        minLength: FormService.VARCHAR_MIN_LENGTH,
                    }),
                    ValidatorsService.forbiddenCharsValidator(FormService.FORBIDDEN_CHARS),
                ],
            }),
            projection: new FormControl<Project.ProjectionEnum>(
                this.getDefaultData()?.projection ?? Project.ProjectionEnum._2154,
                {
                    nonNullable: true,
                },
            ),
        });
    }

    public abstract clear(): void;
    public abstract getDefaultData(): ProjectDefaultData | undefined;
    public abstract onConfirm(form: ProjectCreationEditionForm): Promise<void>;
    public abstract setDefaultData(data?: ProjectDefaultData): void;
}
